import {
  DEBT_POSITIVE_TYPES,
} from '@claimup/shared/constants/expedient';

/**
 * Calculate pending balance for an expedient using debt_activity
 * @param {Object} expedient - The expedient object
 * @returns {number} - The pending balance
 */
export const calculatePendingBalance = expedient => {
  // Use debt_activity if available
  if (expedient?.debt_activity && expedient.debt_activity.length > 0) {
    return expedient.debt_activity.reduce((total, item) => {
      const amount = Math.abs(item.amount || 0);
      if (DEBT_POSITIVE_TYPES.includes(item.type)) {
        return total + amount;
      }
      return total - amount;
    }, 0);
  }

  // Fallback to legacy calculation
  const totalRecuperado =
    expedient?.importes_recuperados?.reduce((sum, imp) => sum + (imp.importe || 0), 0) || 0;
  return (expedient?.importe_deuda || 0) - totalRecuperado;
};

